export default "/assets/images/turn-on-mila-app.webp?c76dbaa8b75f6218aec174cdbb6f17b2";